<template>
  <li
    class="
      @768/layout/width
      layout/align:center
      layout/cursor
      layout/justify:center
      layout/width
    "
    :class="[ initiallyHidden ? 'layout/none' : 'layout/flex' ]"
    style="
      --768--layout--width: 4.8rem;
      --layout--width: 4.0rem;
    "
    >
      <slot />
  </li>
</template>

<script>
  export default {
    props: {
      initiallyHidden: { type: Boolean, required: false, default: false },
    },
  };
</script>
